/**
 * Use for outbound links to other platforms (GCOM, GPI, GPC, TOOLS, etc.), from BuySmart source pages
 * @param url
 */
export const openOutbound = (url: string) => {
  window.open(toOutboundUrl(url), "_blank", "noopener");
};

/**
 * Use for outbound links to other platforms (GCOM, GPI, GPC, TOOLS, etc.), from BuySmart source pages
 * @param url
 */
export const toOutboundUrl = (url: string) => {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === "https:" || parsed.protocol === "http:") {
      parsed.searchParams.set("ref", "buysmart");
      return parsed.href;
    }
  } catch { /* invalid URL — do nothing */ }
  return url;
};